import React from 'react';
import { Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import CookiesService from '../../../services/cookies';

const AuditoriaModal = ({ 
    show, 
    onClose, 
    date, 
    setDate,
    mainData,
    activeRowId,
    marcarAuditoria,
    setShowModal,
    setSelectedDate,
    setCheckedRows,
    setActiveRowId,
    styles 
}) => {
    if (!show) return null;

    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    const minDate = `${yyyy}-${mm}-${dd}`;

    const handleFinalizar = async () => {
        const row = mainData.find(r => r.idMpTriangulacaoRev === activeRowId);
        const userId = CookiesService.getUserId();
        
        if (!date) {
            toast.error('Por favor, selecione a data da auditoria.');
            return;
        }
        
        const payload = {
            idMpTriangulacaoRev: row?.idMpTriangulacaoRev,
            idUsuario: userId,
            dataAuditoria: date
        };
        
        if (!row) return;
        
        await marcarAuditoria(payload);
        setShowModal(false);
        setSelectedDate('');
        setCheckedRows(prev => ({ ...prev, [activeRowId]: true }));
        setActiveRowId(null);
    };

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modalBox}>
                <button
                    className={styles.modalCloseBtn}
                    onClick={onClose}
                    aria-label="Fechar"
                    type="button"
                >
                    ×
                </button>
                <div className={styles.modalDateRow}>
                    <div className={styles.modalDateLabelBox}>
                        Escolha a data da auditoria:
                    </div>
                    <input
                        type="date"
                        className={styles.modalDateInput}
                        value={date}
                        min={minDate}
                        onChange={e => setDate(e.target.value)}
                        onKeyDown={e => e.preventDefault()}
                    />
                </div>
                <Button
                    className={styles.modalBtn}
                    onClick={handleFinalizar}
                    style={{ marginTop: 24 }}
                >
                    finalizar
                </Button>
            </div>
        </div>
    );
};

export default AuditoriaModal;